export default "__VITE_ASSET__CevwOG8i__"